export const Work = [
    {
        id:1,
        name:"Frick-Web",
        description:"It is build a Frick India Limited website on top of the React JS, with styledComponents and Tailwind for creating layout",
        tags:["react","Tailwind","styledComponents","CSS","HTML"],
        
        demo:"https://agency-website-eta.vercel.app/",
        github:"https://github.com/Kshitij1118/FrickWEB"
    },
    {
        id:2,
        name:"Credit-Card Fraud-Detection",
        description:"Collect the data of around 20 years of fraud done on credit card transactions and analyze their outcome.",
        tags:["MySQL","Python","Jupyter"],
        
        demo:"http://react-job-listing-website.codebucks27.vercel.app/",
        github:"https://github.com/Kshitij1118/Fraud-Detection"
        
    },
    {
        id:3,
        name:"E-Book Clone",
        description:"A clone of Dev.to build using Flutter",
        tags:["Flutter"],
        
        demo:"http://devto-clone-codebucks27.vercel.app/",
        github:"https://github.com/Kshitij1118/E-BOOK-by-using-flutter"
    },
    {
        id:4,
        name:"AI Bot",
        description:"Cloud-native neutral search framework for a specific kind of data",
        tags:["Python","Rest API"],
        
        demo:"https://react-sidebar.vercel.app/",
        github:"https://github.com/Kshitij1118/jina/commit/fbb54d0522edd6192722e964a828504e78d39a2e"
       
    },{
        id:5,
        name:"My-Portfolio",
        description:"A Personal Portfolio with in ReactJS with react-router functionalities. Built from scratch.",
        tags:["react","redux","framer-motion","CSS"],
        
        demo:"http://react-redux-todo-app-git-main-codebucks27.vercel.app/",
        github:"https://github.com/Kshitij1118/My-Portfolio"
        
    },
    {
        id:6,
        name:"Suraksha Covid-App",
        description:"Developed a single platform where a customer can see every type of facility like food availability, Red zone areas, Real time Monitoring of social distancing, Vaccine availability, etc. in a critical situation.",
        tags:["react","react-router","css"],
        
        demo:"http://react-responsive-navbar-codebucks27.vercel.app/",
        github:"https://github.com/codebucks27/React-responsive-navbar"
        
    },
    {
        id:6,
        name:"BlitzBlock",
        description:"Build a platform for all the graphic Designer and Artist who can publish their design, arts, creative videos, etc. and sell it as a cryptocurrency. This website gives a special stage for all the creators.",
        tags:["react","react-router","css"],
        
        demo:"http://react-responsive-navbar-codebucks27.vercel.app/",
        github:"https://github.com/Kshitij1118/BlitzBlock"
        
    },
    
  
] 